require([
	'jquery'
], function(
	$
	) {

	'use strict';
	
	if ($('.section-ImageTeasers')) {

		$('.js_teaser').click(function(){
			var link = $(this).find('.link').attr('href');
			window.location.href = link;
		});

	}
});
define("root/Assets/Templates/Html/ImageTeasers/Js/ImageTeasers", function(){});

